module.exports = __webpack_public_path__ + "img/PAYMENT.d7970db0.svg";